<template>
  <div class="articles-page">
    <section class="articles-details">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">الرئيسية</router-link>
            </li>
            <li class="breadcrumb-item active">المقالات</li>
          </ol>
        </nav>
        <img src="../../content/imgs/p1.jpg" alt="" class="head-img" />
        <div class="article-head">
          <h4>طريقة الوقاية من الامراض</h4>
          <i class="fas fa-heart"></i>
        </div>
        <div class="paragraphs">
          <p>
            هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة ، لقد تم توليد
            هذا النص من مولد النص العربى ، حيث يمكنك أن تولد مثل هذا النص أو
            العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها
            التطبيق . هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة ، لقد
            تم توليد هذا النص من مولد النص العربى ، حيث يمكنك أن تولد مثل هذا
            النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى
            يولدها التطبيق هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة ،
            لقد تم توليد هذا النص من مولد النص العربى ، حيث يمكنك أن تولد مثل
            هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى
            يولدها التطبيق . هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة
            . لقد تم توليد هذا النص من مولد النص العربى ، حيث يمكنك أن تولد مثل
            هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى
            يولدها التطبيق هذا النص
          </p>
          <p>
            هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة ، لقد تم توليد
            هذا النص من مولد النص العربى ، حيث يمكنك أن تولد مثل هذا النص أو
            العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها
            التطبيق . هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة ، لقد
            تم توليد هذا النص من مولد النص العربى ، حيث يمكنك أن تولد مثل هذا
            النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى
            يولدها التطبيق هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة ،
            لقد تم توليد هذا النص من مولد النص العربى ، حيث يمكنك أن تولد مثل
            هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى
            يولدها التطبيق . هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة
            . لقد تم توليد هذا النص من مولد النص العربى ، حيث يمكنك أن تولد مثل
            هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى
            يولدها التطبيق هذا النص
          </p>
        </div>
        <articles title="مقالات ذات صلة "></articles>
      </div>
    </section>
  </div>
</template>
<script>
import articles from "../components/Articles.vue";
export default {
  components: {
    articles,
  },
};
</script>
